export default __webpack_public_path__ + "static/media/thanos_snap.53acedfa.png";